import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemoveTextstyle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRemoveTextstyle"><Path fillRule="evenodd" clipRule="evenodd" d="M2.68205 2.69116L21.3049 19.1857L20.3104 20.3086L11.5341 12.5353L10.4455 21.0886L8.95753 20.8992L10.1752 11.3317L1.6875 3.81404L2.68205 2.69116ZM7.99622 2.99988H19.9962V4.49988H12.5568L12.0362 8.59065L10.5482 8.40127L11.0447 4.49988H7.99622V2.99988Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRemoveTextstyle;
